import apiClient from "../api/client";
import { MenuOptionGroup, MenuOptionLink, MenuItem } from "../types/types";
import { Dayjs } from "dayjs";

export const getAllGroups = () =>
  apiClient.get<MenuOptionGroup[]>("/api/MenuOptionGroup");

export const getGroupById = (id: string) =>
  apiClient.get<MenuOptionGroup>(`/api/MenuOptionGroup/${id}`);

export const getGroupOptions = (
  groupGuid: string,
  storeGuid: string
) =>
  apiClient.get<MenuOptionLink[]>(
    "/api/MenuOptionGroupMenuOptionLink/GetMenuOptionGroupMenuOptionLinksWithPriceByMenuOptionGroupId",
    {
      params: { id: groupGuid, storeGuid },
    }
  );

export const getMenuItemsForGroup = (id: string) =>
  apiClient.get<MenuItem[]>(
    "/api/MenuOptionGroup/GetMenuItemsAssociatedToMenuOptionGroup",
    {
      params: { id },
    }
  );

export const getMenuOptionsDropdown = () =>
  apiClient.get<MenuItem[]>("/api/Menu/MenuItemDropDown");

export const createGroup = (data: {
  Name: string;
  DisplayName: string;
  MinSelect: number;
  MaxSelect: number;
  Modifier?: string;
  Active: boolean;
}) =>
  apiClient.post("/api/MenuOptionGroup/AddMenuOptionGroup", data);

export const updateGroup = (data: {
  Guid: string;
  Name: string;
  DisplayName: string;
  MinSelect: number;
  MaxSelect: number;
  Modifier?: string;
  Active: boolean;
}) =>
  apiClient.put("/api/MenuOptionGroup/UpdateMenuOptionGroup", data);

export const deleteGroup = (id: string) =>
  apiClient.delete("/api/MenuOptionGroup/DeleteMenuOptionGroup", {
    params: { id },
  });

export const saveOptionLink = (data: {
  MenuOptionGroupGuid: string;
  MenuGuid: string;
  DisplayName: string;
  SortOrder: number;
  DefaultSelection: boolean;
  ActionListItemGuid?: string;
  StartDate?: Dayjs | null;
  EndDate?: Dayjs | null;
  Active: boolean;
  CreatedBy: string;
}) =>
  apiClient.post(
    "/api/MenuOptionGroupMenuOptionLink/AddMenuOptionGroupMenuOptionLink",
    data
  );

export const updateOptionLink = (data: {
  Guid: string;
  MenuOptionGroupGuid: string;
  MenuGuid: string;
  DisplayName: string;
  SortOrder: number;
  DefaultSelection: boolean;
  ActionListItemGuid?: string;
  StartDate?: Dayjs | null;
  EndDate?: Dayjs | null;
}) =>
  apiClient.put(
    "/api/MenuOptionGroupMenuOptionLink/UpdateMenuOptionGroupMenuOptionLink",
    data
  );

export const deleteOptionLink = (id: string) =>
  apiClient.delete(
    "/api/MenuOptionGroupMenuOptionLink/DeleteMenuOptionGroupMenuOptionLink",
    {
      params: { id },
    }
  );

export const updateSortOrder = (sortValues: Record<string, number>) =>
  apiClient.put(
    "/api/MenuOptionGroupMenuOptionLink/UpdateSortOrderForOptions",
    sortValues
  );

export const getMenuOptionsForMenu = async (menuItemGuid: string | null) => {
  const res = await apiClient.get(
    "/api/MenuOptionGroup/GetMenuOptionsForMenubyId",
    { params: { Id: menuItemGuid } }
  );
  return res.data;
};

export const getMenuOptionGroups = async () => {
  const res = await apiClient.get("/api/MenuOptionGroup");
  return res.data;
};

export const addMenuOptionGroupToMenu = (payload: {
  menuItemId: string;
  menuOptionGroupGuid: string;
  createdByGuid: string;
}) =>
  apiClient.post(
    "/api/MenuOptionGroup/AddMenuItemMenuOptionGroup",
    payload
  );

export const removeMenuOptionGroupFromMenu = (payload: {
  menuItemId: string;
  menuOptionGroupGuid: string;
}) =>
  apiClient.post(
    "/api/MenuOptionGroup/RemoveMenuItemMenuOptionGroup",
    payload
  );

export const updateMenuOptionGroupSortOrder = (payload: {
  menuItemId: string | null;
  menuOptionGroupGuids: string[];
}) =>
  apiClient.post(
    "/api/MenuOptionGroup/UpdateSortOrder",
    payload
  );

  // export const getMenuOptionsForMenu = async (guid: string) => {
  //   const res = await apiClient.get(
  //     "/api/MenuOptionGroup/GetMenuOptionsForMenubyId",
  //     { params: { Id: guid } }
  //   );
  //   return res.data;
  // };
  